import React, { useState } from "react";
import TableView from "./table/table-view";
import Button from "../../../components/buttons/button";
import AddUserModal from "./table/components/add-user-modal";
import TablePaginationCustom from "./table/table-pagination-custom";
import { _userTeamData } from "../../../mock/user-dashboard-mock/data";
import Breadcrumbs from "../../../components/breadcrumbs/breadcrumb";
import TableFilters from "../user-events/table/table-filters";
import { Header } from "../../../components/page-header/Header";

import { useTranslation } from "react-i18next";

import { useGetteamsQuery } from "../../../store/Reducer/teams";


const UserTeam = () => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [search, setsearch] = useState("");

    const {
        data,
        isLoading,
        error,
    } = useGetteamsQuery({ search });

    const breadcrumbItems = [
        { label: t("universal_dashboard_text"), to: '/user-dashboard' },
        { label: t("user_team_breadcurmbs_title") },
    ];

    const openModal = (edit = false, rowData = null) => {
        setIsEdit(edit);
        setSelectedRowData(rowData);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsEdit(false);
        setSelectedRowData(null);
        setIsOpen(false);
    };

    const resetFormData = () => {
        setSelectedRowData(null);
    };

    return (
        <>
            <section className="fontInter min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
                <div className="max-w-7xl mx-auto p-6">
                    <div className="space-y-6">
                        <div className="flex items-center justify-between">
                            <div className="heading">
                                <Header title={t("user_team_title")} breadcrumbItems={breadcrumbItems} />
                            </div>

                            <Button
                                text={t("user_team_btn_text_add_user")}
                                type="button"
                                className="px-6 text-nowrap"
                                onClick={() => openModal(false)}
                            />
                        </div>

                        <div className="w-full min-w-0">
                            {isLoading ? (
                                <div className="pt-16 flex justify-center mt-12 items-center">
                                    <div
                                        className="animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-gray-700 dark:text-gray-100 rounded-full"
                                        role="status"
                                        aria-label="loading"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <TableView
                                        eventsData={data?.data || []}
                                        onEditRow={(rowData) => openModal(true, rowData)}
                                        searching={Boolean(search)}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <AddUserModal
                isOpen={isOpen}
                closeModal={() => {
                    closeModal();
                    resetFormData();
                }}
                isEdit={isEdit}
                rowData={selectedRowData}
            />
        </>
    );
};

export default UserTeam;
